/* HESTIA HOGAR — interacciones propias (sin librerías) */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Aparición al hacer scroll ---------- */
  var observer = null;
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.hh-reveal:not(.hh-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('hh-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('hh-visible'); observer.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Cifras que cuentan ---------- */
  function initCounters(root) {
    var els = (root || document).querySelectorAll('[data-hh-count]:not([data-hh-done])');
    if (!els.length) return;
    function run(el) {
      el.setAttribute('data-hh-done', '1');
      var target = parseFloat(el.getAttribute('data-hh-count')) || 0;
      if (reduceMotion) { el.textContent = target; return; }
      var start = null, dur = 1600;
      function step(t) {
        if (!start) start = t;
        var p = Math.min((t - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased);
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Pestañas de productos ---------- */
  function initTabs(root) {
    (root || document).querySelectorAll('[data-hh-tabs]').forEach(function (wrap) {
      if (wrap.dataset.hhReady) return;
      wrap.dataset.hhReady = '1';
      var tabs = wrap.querySelectorAll('[role="tab"]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            var on = t === tab;
            t.setAttribute('aria-selected', on ? 'true' : 'false');
            var panel = wrap.querySelector('#' + t.getAttribute('aria-controls'));
            if (panel) { panel.hidden = !on; if (on) initReveal(panel); }
          });
        });
      });
    });
  }

  /* ---------- Página de producto ---------- */
  function initProducto(root) {
    (root || document).querySelectorAll('[data-hh-producto]').forEach(function (sec) {
      if (sec.dataset.hhReady) return;
      sec.dataset.hhReady = '1';

      /* Galería: pista con desplazamiento + miniaturas */
      var track = sec.querySelector('.hh-pdp__track');
      var thumbs = sec.querySelectorAll('.hh-pdp__thumb');
      var dots = sec.querySelectorAll('.hh-pdp__dot');
      function goTo(i) {
        if (!track) return;
        var slide = track.children[i];
        if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      var counter = sec.querySelector('[data-hh-counter]');
      function mark(i) {
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        if (counter) counter.textContent = i + 1;
      }

      /* Tarjetas de oferta: precio por unidad y selección visual */
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'MXN';
      var fmt;
      try { fmt = new Intl.NumberFormat('es-MX', { style: 'currency', currency: currency }); } catch (e) { fmt = null; }
      sec.querySelectorAll('[data-hh-unit]').forEach(function (el) {
        var m = (el.getAttribute('data-title') || '').match(/(\d+)/);
        var units = parseInt(el.getAttribute('data-units'), 10) || (m ? parseInt(m[1], 10) : 1);
        if (!units || units < 1) units = 1;
        var cents = parseInt(el.getAttribute('data-cents'), 10) || 0;
        if (fmt && cents) el.textContent = fmt.format(cents / units / 100) + ' ' + (el.getAttribute('data-sufijo') || 'c/u');
      });
      function markOffers() {
        sec.querySelectorAll('.hh-offer').forEach(function (l) {
          var inp = l.querySelector('input');
          l.classList.toggle('is-selected', !!(inp && inp.checked));
        });
      }
      sec.addEventListener('change', function (e) { if (e.target.closest('.hh-offer')) markOffers(); });
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); mark(i); }); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); mark(i); }); });
      if (track) {
        var tmr;
        track.addEventListener('scroll', function () {
          clearTimeout(tmr);
          tmr = setTimeout(function () {
            var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
            mark(i);
          }, 80);
        }, { passive: true });
      }

      /* Variantes */
      var dataEl = sec.querySelector('[data-hh-variants]');
      var variants = [];
      try { variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (e) { variants = []; }
      var form = sec.querySelector('form[action*="/cart/add"]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var priceNow = sec.querySelectorAll('[data-hh-price]');
      var priceWas = sec.querySelectorAll('[data-hh-compare]');
      var saveEls = sec.querySelectorAll('[data-hh-save]');
      var buyBtns = sec.querySelectorAll('[data-hh-buy]');
      var selects = sec.querySelectorAll('[data-hh-option]');

      function currentOptions() {
        var opts = [];
        selects.forEach(function (group) {
          var pos = parseInt(group.getAttribute('data-hh-option'), 10);
          var checked = group.querySelector('input:checked');
          opts[pos] = checked ? checked.value : null;
        });
        return opts;
      }
      function update() {
        if (!variants.length || !selects.length) return;
        var opts = currentOptions();
        var v = variants.find(function (x) {
          return x.options.every(function (o, i) { return opts[i] == null || o === opts[i]; });
        });
        sec.querySelectorAll('[data-hh-option-value]').forEach(function (el) {
          el.textContent = opts[parseInt(el.getAttribute('data-hh-option-value'), 10)] || '';
        });
        if (!v) {
          buyBtns.forEach(function (b) { b.disabled = true; });
          return;
        }
        if (idInput) idInput.value = v.id;
        priceNow.forEach(function (el) { el.textContent = v.price; });
        priceWas.forEach(function (el) { el.textContent = v.compare || ''; el.hidden = !v.compare; });
        saveEls.forEach(function (el) { el.textContent = v.save || ''; el.hidden = !v.save; });
        buyBtns.forEach(function (b) {
          b.disabled = !v.available;
          var label = b.querySelector('[data-hh-label]');
          if (label) label.textContent = v.available ? b.getAttribute('data-hh-label-on') : b.getAttribute('data-hh-label-off');
        });
        if (v.media != null) {
          var slides = track ? Array.prototype.slice.call(track.children) : [];
          var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') == v.media; });
          if (idx > -1) { goTo(idx); mark(idx); }
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      selects.forEach(function (g) { g.addEventListener('change', update); });

      /* Cantidad */
      var qty = sec.querySelector('.hh-qty input');
      sec.querySelectorAll('[data-hh-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!qty) return;
          var n = parseInt(qty.value, 10) || 1;
          n += parseInt(btn.getAttribute('data-hh-qty'), 10);
          qty.value = Math.max(1, n);
        });
      });

      /* Ofertas por cantidad: la tarjeta elegida fija la cantidad y el precio mostrado */
      var qoBox = sec.querySelector('[data-hh-qoffers]');
      var qoQty = sec.querySelector('[data-hh-qo-qty]');
      function applyQo() {
        var inp = qoBox && qoBox.querySelector('input:checked');
        if (!inp) return;
        if (qoQty) qoQty.value = inp.value;
        priceNow.forEach(function (el) { el.textContent = inp.getAttribute('data-price'); });
        var was = inp.getAttribute('data-was'), save = inp.getAttribute('data-save');
        priceWas.forEach(function (el) { el.textContent = was || ''; el.hidden = !was; });
        saveEls.forEach(function (el) { el.textContent = save || ''; el.hidden = !save; });
      }
      if (qoBox) { qoBox.addEventListener('change', applyQo); applyQo(); }

      /* Releasit: al abrir su formulario, marcar la misma oferta (1/2/3) elegida en la página */
      var rsiHook = sec.querySelector('#rsi-button-hook');
      if (rsiHook && qoQty) {
        rsiHook.addEventListener('click', function () {
          var want = parseInt(qoQty.value, 10) || 1;
          var tries = 0;
          (function tick() {
            var ls = Array.prototype.filter.call(document.querySelectorAll('label.rsi-quantity-product'), function (l) { return l.offsetParent !== null; });
            if (ls.length) { if (want > 1 && ls[want - 1]) ls[want - 1].click(); return; }
            if (++tries < 40) setTimeout(tick, 150);
          })();
        }, true);
      }

      /* Línea de entrega: fechas en días hábiles (lun-vie) */
      sec.querySelectorAll('[data-hh-entrega]').forEach(function (box) {
        var f;
        try { f = new Intl.DateTimeFormat('es-MX', { weekday: 'short', day: 'numeric', month: 'short' }); } catch (e) { return; }
        function habil(n) {
          var d = new Date();
          while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
          return d;
        }
        function fmtD(d) {
          var x = f.format(d).replace(/\./g, '').replace(/ de /g, ' ');
          return x.charAt(0).toUpperCase() + x.slice(1);
        }
        function set(k, t) { var el = box.querySelector('[data-hh-fecha="' + k + '"]'); if (el) el.textContent = t; }
        var min = parseInt(box.getAttribute('data-min'), 10) || 2;
        var max = parseInt(box.getAttribute('data-max'), 10) || 5;
        set('0', fmtD(new Date()));
        set('1', fmtD(habil(1)));
        set('rango', fmtD(habil(min)) + ' – ' + fmtD(habil(max)));
      });

      /* Comprar ahora: ir directo a finalizar compra */
      var returnTo = form ? form.querySelector('input[name="return_to"]') : null;
      sec.querySelectorAll('[data-hh-buynow]').forEach(function (b) {
        b.addEventListener('click', function () { if (returnTo) returnTo.value = '/checkout'; });
      });
      sec.querySelectorAll('[data-hh-addcart]').forEach(function (b) {
        b.addEventListener('click', function () { if (returnTo) returnTo.value = '/cart'; });
      });

      /* Barra fija en móvil */
      var sticky = document.querySelector('[data-hh-sticky="' + sec.id + '"]');
      var anchor = sec.querySelector('.hh-pdp__actions');
      if (sticky && anchor && 'IntersectionObserver' in window) {
        var so = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', passed);
          });
        });
        so.observe(anchor);
        var stickyBtn = sticky.querySelector('button');
        if (stickyBtn) stickyBtn.addEventListener('click', function () {
          var rsi = sec.querySelector('#rsi-button-hook button, #rsi-button-hook [role="button"], [data-rsi-cod-button]');
          var buy = sec.querySelector('[data-hh-buynow]');
          if (rsi) rsi.click();
          else if (buy && !buy.disabled && buy.offsetParent !== null) buy.click();
          else anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    });
  }

  /* Enlaces "subir a comprar" */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#hh-comprar"]');
    if (!a) return;
    var target = document.getElementById('hh-comprar');
    if (!target) { a.setAttribute('href', '/collections/all'); return; }
    e.preventDefault();
    // Con Releasit: abrir directo el formulario de pedido (respeta la oferta elegida)
    var rsi = document.querySelector('#rsi-button-hook #rsi_buy_now_button, #rsi-button-hook button');
    if (rsi) { rsi.click(); return; }
    // Sin Releasit: subir a las ofertas / botón visible
    var sec = target.closest('[data-hh-producto]');
    var dest = (sec && (sec.querySelector('[data-hh-qoffers]') || sec.querySelector('.hh-offers'))) || target;
    if (dest.offsetParent === null) dest = (sec && sec.querySelector('.hh-pdp__info')) || dest;
    dest.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
  });

  /* Releasit: textos que la app deja en inglés */
  var RSI_TXT = { 'Default rate': 'Envío gratis', 'Discounts': 'Descuento', 'Discount': 'Descuento' };
  var rsiTimer = null;
  function fixRsiText() {
    rsiTimer = null;
    document.querySelectorAll('[class*="rsi-layout-wrapper"], [class*="rsi-shipping-rates"], [class*="rsi-summary"]').forEach(function (box) {
      var w = document.createTreeWalker(box, NodeFilter.SHOW_TEXT);
      var n;
      while ((n = w.nextNode())) {
        var t = n.nodeValue.trim();
        if (RSI_TXT[t]) n.nodeValue = n.nodeValue.replace(t, RSI_TXT[t]);
      }
    });
  }
  if ('MutationObserver' in window) {
    new MutationObserver(function () { if (!rsiTimer) rsiTimer = setTimeout(fixRsiText, 120); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }

  /* Videos tipo GIF: se reproducen solos (sin controles) cuando están a la vista */
  function initGifs(root) {
    var vids = (root || document).querySelectorAll('video.hh-gif');
    if (!vids.length) return;
    vids.forEach(function (v) { v.muted = true; v.loop = true; v.playsInline = true; v.removeAttribute('controls'); });
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { v.play().catch(function () {}); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { var p = e.target.play(); if (p && p.catch) p.catch(function () {}); }
        else e.target.pause();
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  }

  function initAll(root) {
    initGifs(root);
    initReveal(root);
    initCounters(root);
    initTabs(root);
    initProducto(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  /* Editor de Shopify: re-iniciar al cargar/editar secciones */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
